<template>
  <section class="l-section for_sharing">
    <div class="l-section-h i-cf">
      <div class="w-sharing type_simple align_left color_default">
        <button v-for="item in sharingItems"
                :key="item.name"
                type="button"
                class="w-sharing-item"
                :class="item.name"
                :title="item.title"
                @click.prevent="onShare(item.name)">
          <span class="w-sharing-icon"></span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>

  export default {
    name: 'SharingPanel',
    props: {
      options: null
    },
    data() {
      return {
        sharingItems: [
          {
            title: this.$t('Поділитися'),
            name: 'facebook'
          },
          {
            title: this.$t('Твітнути це'),
            name: 'twitter'
          },
          {
            title: this.$t('Запінити це'),
            name: 'pinterest'
          }
        ]
      }
    },
    methods: {
      onShare(name) {
        if (!this.options) return
        switch (name) {
          case 'facebook':
            window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.options.url) + '&t=' + encodeURIComponent(this.options.text) + '', '', 'toolbar=0, status=0, width=900, height=500')
            break
          case 'twitter':
            window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.options.text) + '&url=' + encodeURIComponent(this.options.url), '', 'toolbar=0, status=0, width=650, height=360')
            break
          case 'pinterest':
            window.open('http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(this.options.url) + '&media=' + encodeURIComponent(this.options.image) + '&description=' + encodeURIComponent(this.options.text), 'pinterest', 'toolbar=no,width=700,height=300')
            break
        }
      }
    }
  }
</script>

<style lang="less" scoped>

  .w-sharing-item {
    background: transparent;
  }
</style>
